/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { useMemo } from 'react';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { getTestProps } from 'lib/testing/utils';
import { useRealPathName } from 'lib/hooks/useRealPathName';
import ArticleSearchWidget from 'widgets/ArticleSearch';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ArticleSearch = (props)=>{
    const isEditing = useIsEditing();
    const path = useRealPathName();
    const id = props?.params?.RenderingIdentifier;
    const sourceId = useMemo(()=>process.env.NEXT_PUBLIC_SEARCH_NEWS_SOURCE_ID ? [
            process.env.NEXT_PUBLIC_SEARCH_NEWS_SOURCE_ID
        ] : [
            '1174083'
        ], []);
    return /*#__PURE__*/ _jsx("section", {
        id: id ? id : 'article-search',
        "data-component": "authorable/shared/search/articlesearch",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-search-result-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(ArticleSearchWidget, {
            rfkId: "rfkid_reports_insights",
            sources: sourceId,
            ...props
        }, path)
    });
};
export const Default = withStandardComponentWrapper(ArticleSearch);
